export const Blank = (value) => {
    return (
        value === undefined ||
        value === null ||
        (value?.value?.trim() === "") ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === "object" && !Array.isArray(value) && Object.keys(value).length === 0)
    )
}
